export default class CardHeaderText extends React.Component {
  render() {
    const {className, ...restProps} = this.props

    return (
      <span className={classNames("components-card-header-text", className)} {...restProps} />
    )
  }
}
